<template>
    <!--弹窗-->
    <el-dialog
        width="500px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            :model="formData"
            :rules="rules"
            label-width="120px"
            size="mini"
        >
            <el-form-item label="ASIN：" prop="asin">
                <el-input
                    v-model="formData.asin"
                    style="width: 160px;margin-right:20px;"
                    maxlength="10"
                    placeholder="请输入ASIN"
                    v-loading="loading"
                ></el-input>
            </el-form-item>
            <el-form-item label="负责人:" class="query-form-item" prop="person">
                <el-input
                    v-model="formData.person"
                    placeholder="请输入负责人"
                    style="width:160px"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="店铺名称:" class="query-form-item" prop="shop_name">
                <el-select
                    v-model="formData.shop_name"
                    placeholder="请选择店铺名称"
                    ref="carrerSelect"
                    style="width: 160px;"
                    size="mini"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="item in list"
                        :key="item.id"
                        :label="item.shop_name"
                        :value="item.shop_name"
                    >
                    </el-option>
                </el-select>

            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/etyma/etyma'
import * as apis from '@/api/Product/Product'
import {shop_name_list, track_asin_index_add} from '@/api/Product/Product'

export default {
    data() {
        return {
            list:[],
            loading: false,
            formData: {
                asin: '',
                state: '',
                person: '',
                shop_name: '',
            },

            stateArr: [
                {
                    name: '美国',
                    value: 'US'
                },
                {
                    name: '英国',
                    value: 'UK'
                },
                {
                    name: '德国',
                    value: 'DE'
                }
            ],
            rules: {
                state: [
                    {
                        required: true,
                        message: '请选择国家',
                        trigger: 'blur'
                    }
                ],
                asin: [
                    {
                        required: true,
                        message: '请输入asin',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    watch: {
        'visible': {
            handler(val){
                val && this.getShopList()
            }
        }
    },
    methods: {
        getShopList(){
            shop_name_list().then(res => {
                if (res.code === 0) {
                    this.list = res.data || []
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
        },
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.loading = true
                    apis.track_asin_index_add(this.formData)
                        .then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                })
                                this.handleClose(false)
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.message
                                })
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message:
                                    '网络出现问题，请查看数据是否添加完成！'
                            })
                        })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.formData = {}
            this.$refs['formData'].resetFields()
            this.loading = false
            this.$emit('close-callback', isshow == true)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
</style>
